module.exports = __webpack_public_path__ + "static/media/IMG_5919-min.6d45f96c.JPG";